import { getRate } from './rate'
import { formatDate } from './date'

export default {
  install (app) {
    app.config.globalProperties.$filters = {
      getRate,
      formatDate
    }
  }
}
